// extracted by mini-css-extract-plugin
module.exports = {"inner":"Dev_inner__3PtYs","pulse":"Dev_pulse__3dy0g","hover":"Dev_hover__KUzXS","text":"Dev_text__1LCPT","text1":"Dev_text1__30hVa"};